var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49984 15.6667C12.5499 15.6667 15.8332 12.3834 15.8332 8.33333C15.8332 4.28324 12.5499 1 8.49984 1C4.44975 1 1.1665 4.28324 1.1665 8.33333C1.1665 12.3834 4.44975 15.6667 8.49984 15.6667Z",
    stroke: "#A5ACCF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49967 13.0001C8.86786 13.0001 9.16634 12.7016 9.16634 12.3334C9.16634 11.9652 8.86786 11.6667 8.49967 11.6667C8.13148 11.6667 7.83301 11.9652 7.83301 12.3334C7.83301 12.7016 8.13148 13.0001 8.49967 13.0001Z",
    fill: "#A5ACCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06836 4.70667C8.38836 4.12334 10.0964 4.19267 10.6797 5.13667C11.263 6.08067 10.8604 7.17867 9.86036 8.02601C8.86036 8.87334 8.49969 9.33334 8.49969 10",
    stroke: "#A5ACCF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.4a8cb1887f4e3ea9ae5dbe31adddfc83.svg";
export { ForwardRef as ReactComponent };